module.exports = __webpack_public_path__ + "img/hav_no.3d95aff7.png";